const willowTree = require("./willow_tree.mp3");

export const playlist = [
  {
    name: "Adventure song",
    file: willowTree,
    artist: "El PePe",
  },
];
